const encrypt = publicKey => {
  return import('node-rsa').then(({ default: NodeRSA }) => {
    const key = new NodeRSA(`-----BEGIN PUBLIC KEY-----\n${publicKey}\n-----END PUBLIC KEY-----`);
    key.setOptions({ encryptionScheme: 'pkcs1' });
    return field => key.encrypt(field, 'base64');
  });
};

export const encryptCredit = ({ credit, fdPublicKey, isUsingTokenEx = false }) =>
  encrypt(fdPublicKey).then(encryptWithKey => {
    return {
      ...credit,
      cardNumber: encryptWithKey(credit.cardNumber),
      expiryDate: {
        month: isUsingTokenEx ? credit.expiryDate.month : encryptWithKey(credit.expiryDate.month),
        year: isUsingTokenEx ? credit.expiryDate.year : encryptWithKey(credit.expiryDate.year),
      },
      securityCode: encryptWithKey(credit.securityCode),
    };
  });

export { getStoredPrepaidCard, storePrepaidCard } from './store-prepaid-card';
